import Progress from './progress';
export default Progress;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/progress/index.js
// module id = 352
// module chunks = 0